import { memo, useRef } from 'react';
import useMermaid from '../hooks/useMermaid';

// Keep React's HTML replacement separate from scroll progress and active-section
// updates, so those updates cannot replace Mermaid's rendered SVGs.
export default memo(function BlogArticle({ html, theme }) {
    const article = useRef(null);
    useMermaid(article, html, theme);
    return <article ref={article} className="blog-prose" dangerouslySetInnerHTML={{ __html: html }} />;
});
